var map = {
	"./assistenza-strutture-bg.jpg": "598ac",
	"./blue.jpg": "8c2c",
	"./default-bg.png": "2fb4",
	"./fsi-bg.png": "d0c8",
	"./intesa-bg.jpg": "0f8b",
	"./pmed-bg.jpg": "560d",
	"./rbsistemawelfare-bg.png": "bc6e",
	"./sfondo-blu-gradiente.jpg": "ea88",
	"./sfondo-verde-gradiente.png": "3a1d",
	"./verde-monocolore.png": "ffa2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ca96";